import React, { Component } from 'react'
import { Form } from 'antd';
import { Dropdown } from '../../../../../components/common/dropdown';

export class TypeOfRental extends Component {
  state = {
    rental_service_types: [],
  }

  onSelect = data => {
    const { onChangeForm } = this.props;
    onChangeForm('rental_service_type_code', data.code);
  }

  render() {
    const { rental_service_types } = this.state;
    const { limitEdit } = this.props;
    return <>
      <div className="title-contract title-special">
        6. Loại hình cho thuê xe*
        </div>
      <Form.Item
        name="rental_service_type_code"
        wrapperCol={24}
        className="ant-col-24"
        rules={[
          {
            required: true,
            message: `Vui lòng chọn loại hình cho thuê xe!`,
          }
        ]}>
        <Dropdown 
          disabled={!limitEdit}
          select={this.onSelect}
          className="dropdown-full" 
          title="Chọn loại hình" 
          menu={rental_service_types} />
      </Form.Item>
    </>
  }
}
